export default "__VITE_ASSET__wmMrRMpU__"